import { FormEvent, useEffect, useState } from "react";
import {
  Button,
  Alert,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
} from "reactstrap";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import AppSpinner from "../../elements/AppSpinner";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import API from "../../api/api/API";
import AdminNavbar from "../../components/Navbars/IndexNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import { useAtomValue } from "jotai";
import { IsMobileAtom } from "../../App";
import { useAppConfig } from "./Register";

function SendPhoneVerification() {
  const [phone, setPhone] = useState<any>("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [search] = useSearchParams();
  const appConfig = useAppConfig(search.get("app"));
  const navigate = useNavigate();
  const isMobile = useAtomValue(IsMobileAtom);

  useEffect(() => {
    if (!Cookies.get("registrationToken") && !search.get("registrationToken")) {
      navigate("/login", { replace: true });
      return;
    }
  }, [search]);

  function onSetError(value: string) {
    setError(value);

    if (value) {
      setTimeout(() => {
        setError("");
      }, 6000);
    }
  }

  function sendVerification(e: FormEvent) {
    e.preventDefault();

    setSubmitting(true);

    API.sendIdentityVerification(phone)
      .then(
        (data) => {
          const identityToken = data.data.data.identityToken;
          const phone = data.data.data.phone;

          Cookies.set("identityToken", identityToken, {
            sameSite: "strict",
            secure: window.location.origin.startsWith("https"),
          });
          Cookies.set("phone", phone, {
            sameSite: "strict",
            secure: window.location.origin.startsWith("https"),
          });

          if (appConfig) {
            search.set("phone", phone);
            search.set("identityToken", identityToken);
          }

          let url = "/register/phone/verify";

          if (appConfig) {
            url += `?${search.toString()}`;
          }

          navigate(url, { replace: true });
        },
        (error) => {
          console.error(error);

          onSetError(
            "We're having trouble sending your verification code. Please try again."
          );
        }
      )
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <>
      <AppHelmet title="Verify Your Account - GrowthCloud.com" />
      <div className="main-content">
        <AdminNavbar bg="" logo={appConfig?.Logo} />
        <Container
          fluid
          className="pb-5"
          style={{ height: "calc(100vh - 125px - 3rem)" }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                flexGrow: 1,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Row className="justify-content-center mt-4 mt-sm-6">
                <Col lg="6" xl="5" md="8">
                  <div>
                    <h2 className="text-dark mb-4 mt-5">Verify Your Account</h2>
                    <div
                      className="tw:mt-0 tw:font-medium tw:text-dark tw:mb-3"
                      style={{ fontSize: 15 }}
                    >
                      Enter your mobile phone number and receive a verification
                      code.
                    </div>
                    {!appConfig && (
                      <div
                        className="tw:mt-0 tw:font-medium tw:text-dark tw:mb-4"
                        style={{ fontSize: 15 }}
                      >
                        Want to start over?
                        <Link className="tw:text-primary tw:ml-2" to="/login">
                          Return to sign in
                        </Link>
                      </div>
                    )}

                    <Form role="form" onSubmit={sendVerification}>
                      <FormGroup>
                        <h5 className="text-dark">Mobile Phone</h5>
                        <PhoneInput
                          autoFocus={!isMobile}
                          className="crm-record-phoneinput"
                          defaultCountry="US"
                          international
                          placeholder="Phone Number"
                          value={phone}
                          onChange={(val) => setPhone(val)}
                          error={
                            phone
                              ? isValidPhoneNumber(phone)
                                ? undefined
                                : "Invalid phone number"
                              : "Phone number required"
                          }
                        />
                      </FormGroup>
                      <div className="tw:text-left">
                        <Button
                          className="tw:mb-4 tw:px-4 tw:bg-primary tw:border-primary"
                          color="primary"
                          type="submit"
                          disabled={
                            !phone || !isValidPhoneNumber(phone) || submitting
                          }
                        >
                          {!submitting ? (
                            <>Send Verification</>
                          ) : (
                            <AppSpinner size="sm" color="white" />
                          )}
                        </Button>
                      </div>
                    </Form>
                    {error ? <Alert color="danger">{error}</Alert> : null}
                    <div className="tw:mt-0">
                      <p
                        className="text-light tw:mb-0"
                        style={{ lineHeight: 1.2 }}
                      >
                        <small>
                          By clicking the Send Verification button, you agree to
                          our Privacy Policy and Terms of Use. Standard text and
                          data rates may apply.
                        </small>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="tw:mt-5">
            <AuthFooter />
          </div>
        </Container>
      </div>
    </>
  );
}

export default SendPhoneVerification;
